import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import useEmployeeHistory from '../../../hooks/useEmployeeHistory';

export default function HistoryFilters({ filters, onFilterChange, onClear }) {
  const { getAvailableFilters } = useEmployeeHistory();
  const [availableFilters, setAvailableFilters] = useState(null);

  useEffect(() => {
    getAvailableFilters().then((result) => {
      if (result.success) setAvailableFilters(result);
    });
  }, []); // eslint-disable-line

  const getEventTypes = () => {
    if (!availableFilters || !filters.categoria) return [];
    return availableFilters.tipos_evento[filters.categoria] || [];
  };

  const activeFiltersCount = [
    filters.categoria,
    filters.tipo_evento,
    filters.fecha_desde,
    filters.fecha_hasta,
    filters.activo !== 'true'
  ].filter(Boolean).length;

  if (!availableFilters) {
    return (
      <div className="flex items-center gap-2 p-3 bg-gray-50 border border-gray-200 rounded-lg">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        <span className="text-xs text-gray-400">Cargando filtros...</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 p-3 bg-gray-50 border border-gray-200 rounded-lg flex-wrap">

      {/* Categoría */}
      <select
        value={filters.categoria || ''}
        onChange={(e) => onFilterChange({ categoria: e.target.value, tipo_evento: '' })}
        className="px-3 py-1.5 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:border-blue-400"
      >
        <option value="">Todas las categorías</option>
        {availableFilters.categorias.map((cat) => (
          <option key={cat.value} value={cat.value}>{cat.label}</option>
        ))}
      </select>

      {/* Tipo de evento (cascaded por categoría) */}
      <select
        value={filters.tipo_evento || ''}
        onChange={(e) => onFilterChange({ tipo_evento: e.target.value })}
        disabled={!filters.categoria}
        className="px-3 py-1.5 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:border-blue-400 disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        <option value="">Todos los tipos</option>
        {getEventTypes().map((type) => (
          <option key={type.value} value={type.value}>{type.label}</option>
        ))}
      </select>

      {/* Desde */}
      <input
        type="date"
        value={filters.fecha_desde || ''}
        onChange={(e) => onFilterChange({ fecha_desde: e.target.value })}
        className="px-3 py-1.5 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:border-blue-400"
        placeholder="Desde"
      />

      {/* Hasta */}
      <input
        type="date"
        value={filters.fecha_hasta || ''}
        onChange={(e) => onFilterChange({ fecha_hasta: e.target.value })}
        className="px-3 py-1.5 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:border-blue-400"
        placeholder="Hasta"
      />

      {/* Estado */}
      <select
        value={filters.activo || 'true'}
        onChange={(e) => onFilterChange({ activo: e.target.value })}
        className="px-3 py-1.5 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:border-blue-400"
      >
        <option value="true">Solo activos</option>
        <option value="false">Solo inactivos</option>
        <option value="all">Todos</option>
      </select>

      {/* Limpiar */}
      {activeFiltersCount > 0 && (
        <button
          onClick={onClear}
          className="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1"
        >
          <X size={12} /> Limpiar filtros
        </button>
      )}
    </div>
  );
}
